import React, { useState, useEffect } from 'react';
import * as api from '../../../api';
import * as crypto from '../../../crypto';

const avatarUrlCache = new Map(); // fileId -> objectURL

export default function DecryptedAvatar({ avatarJson, displayName, style = {} }) {
  const [imgUrl, setImgUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!avatarJson || !avatarJson.startsWith('{"fileId"')) {
      setLoading(false);
      return undefined;
    }
    let active = true;
    let createdUrl = "";
    const load = async () => {
      try {
        const att = JSON.parse(avatarJson);
        
        // Return cached URL if available
        if (avatarUrlCache.has(att.fileId)) {
          setImgUrl(avatarUrlCache.get(att.fileId));
          setLoading(false);
          return;
        }

        const blob = await api.downloadFileAttachment(att.fileId);
        const decrypted = await crypto.decryptFileSymmetric(blob, att.keyHex, att.ivHex);
        if (active) {
          createdUrl = URL.createObjectURL(decrypted);
          avatarUrlCache.set(att.fileId, createdUrl);
          setImgUrl(createdUrl);
          setLoading(false);
        }
      } catch (err) {
        console.error("Failed to decrypt GSN avatar:", err);
        if (active) {
          setError(true);
          setLoading(false);
        }
      }
    };
    load();
    return () => {
      active = false;
    };
  }, [avatarJson]);

  const initial = displayName ? displayName.charAt(0).toUpperCase() : '?';
  let hash = 0;
  for (let i = 0; i < (displayName || '').length; i++) {
    hash = (displayName || '').charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `hsl(${hash % 360}, 50%, 45%)`;

  if (loading) {
    return (
      <div className="gsn-avatar" style={{ backgroundColor: 'rgba(255,255,255,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center', ...style }}>
        ⏳
      </div>
    );
  }

  if (error || !imgUrl) {
    const isEmoji = avatarJson && avatarJson.length <= 4;
    return (
      <div className="gsn-avatar" style={{ backgroundColor: color, display: 'flex', alignItems: 'center', justifyContent: 'center', ...style }}>
        {isEmoji ? avatarJson : initial}
      </div>
    );
  }

  return (
    <img
      src={imgUrl}
      alt={displayName}
      className="gsn-avatar"
      style={{ objectFit: 'cover', border: '1px solid var(--border-color)', ...style }}
    />
  );
}
